import { SLICE_NAME } from "../../model/types/types";

export const ActionType = {
  TOGGLE_DIALOG: `${SLICE_NAME}/toggle_dialog`,
  DIALOG_SUBMIT_BUTTON_CLICKED: `${SLICE_NAME}/submit_button_clicked`,
} as const;
